import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { KIOSK_STEPS } from '@/constants/routes';
import { StepProgress } from './StepProgress';

interface HeaderProps {
  title: string;
  currentStep: number;
  showBack?: boolean;
}

export function Header({ title, currentStep, showBack = false }: HeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="app-header pt-safe">
      <Container className="py-2">
        {/* Top row: back / kiosk status / title / actions */}
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div className="d-flex align-items-center gap-2 min-w-0">
            {showBack && (
              <button
                type="button"
                aria-label="Go back"
                onClick={() => navigate(-1)}
                className="btn bg-surface-low text-on-surface rounded-3 d-flex align-items-center justify-content-center tap-target active-press border-0 flex-shrink-0"
              >
                <i className="bi bi-arrow-left" style={{ fontSize: 18 }} />
              </button>
            )}
            <div className="d-flex flex-column min-w-0">
              <span className="text-headline-sm text-on-surface text-truncate">{title}</span>
            </div>
          </div>

          {/* <div className="d-flex align-items-center gap-2 flex-shrink-0">
            <a
              href="#assistance"
              aria-label="Get assistance"
              className="btn bg-surface-low text-primary rounded-3 d-none d-md-flex align-items-center gap-1 tap-target active-press border-0 text-label-md px-3"
            >
              <i className="bi bi-question-circle" style={{ fontSize: 18 }} />
              <span>Assistance</span>
            </a>
            <a
              href="#assistance"
              aria-label="Get assistance"
              className="btn bg-surface-low text-primary rounded-3 d-flex d-md-none align-items-center justify-content-center tap-target active-press border-0"
            >
              <i className="bi bi-question-circle" style={{ fontSize: 18 }} />
            </a>
            <div
              className="rounded-circle bg-primary d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: 36, height: 36 }}
            >
              <i className="bi bi-person-fill text-white" />
            </div>
          </div> */}
        </div>

        {/* Mobile / tablet: compact numbered progress track */}
        <div className="d-lg-none pt-2 pb-1">
          <StepProgress currentStep={currentStep} />
        </div>

        {/* Desktop: full step detail cards */}
        <div className="d-none d-lg-flex align-items-center gap-2 pt-3 pb-2">
          {KIOSK_STEPS.map((step, index) => {
            const isActive = step.step === currentStep;
            const isComplete = step.step < currentStep;
            return (
              <div key={step.step} className="d-flex align-items-center flex-grow-1">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className={[
                      'd-flex align-items-center justify-content-center rounded-circle text-label-md fw-semibold flex-shrink-0',
                      isActive || isComplete
                        ? 'bg-primary text-white'
                        : 'bg-surface-highest text-on-surface-variant',
                    ].join(' ')}
                    style={{ width: 32, height: 32 }}
                  >
                    {isComplete ? <i className="bi bi-check-lg" /> : step.step}
                  </span>
                  <div className="d-flex flex-column">
                    <span className="text-label-lg text-on-surface">{step.label}</span>
                    <span className="text-body-sm text-on-surface-variant">{step.description}</span>
                  </div>
                </div>
                {index < KIOSK_STEPS.length - 1 && (
                  <div
                    className="flex-grow-1 mx-3 rounded-pill"
                    style={{
                      height: 3,
                      backgroundColor: isComplete
                        ? 'var(--kiosk-primary)'
                        : 'var(--kiosk-surface-container-highest)',
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </Container>
    </header>
  );
}
